import { authenticatedImageFetch, authenticatedStudentImageFetch } from "../utils/utils";

export async function previewMedia(path) {
	try {
		if (!path) return null;
		
		// Si le chemin est déjà encodé (contient %), on l'utilise tel quel
		// Sinon, on nettoie et encode segment par segment
		let encodedPath;
		if (path.includes('%')) {
			// Le chemin est déjà encodé (venant de generateFileUrl)
			encodedPath = path;
		} else {
			// Nettoyer le chemin et encoder seulement les caractères nécessaires
			const cleanPath = path.replace(/^\/+|\/+$/g, ''); // Enlever les slashes au début/fin
			const pathParts = cleanPath.split('/').map(part => encodeURIComponent(part));
			encodedPath = pathParts.join('/');
		}
		
		const response = await authenticatedImageFetch(`preview/${encodedPath}`, { method: "GET" });

		if (!response.ok) {
			throw new Error(`Erreur HTTP: ${response.status} ${response.statusText}`);
		}

		let blob = await response.blob();

		if (blob.type !== "application/pdf") {
			blob = new Blob([blob], { type: "application/pdf" });
		}

		const url = URL.createObjectURL(blob) + "#toolbar=0";
		return url;
	} catch (error) {
		console.error("Erreur lors du préchargement du fichier:", error);
		return null;
	}
}

export async function downloadMedia(path, filename, isStudent = false) {
	try {
		if (!path) {
			throw new Error("Chemin du fichier manquant");
		}

		const response = isStudent ? await authenticatedStudentImageFetch(path, {
			method: "GET"
		}) : await authenticatedImageFetch(path, {
			method: "GET"
		});

		if (!response.ok) {
			throw new Error(`Erreur HTTP: ${response.status} ${response.statusText}`);
		}

		const blob = await response.blob();
		const url = URL.createObjectURL(blob);
		const link = document.createElement("a");
		link.href = url;
		link.download = filename || "fichier";
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
		URL.revokeObjectURL(url);

		return true;
	} catch (error) {
		console.error("Erreur lors du téléchargement du fichier:", error);
		throw error;
	}
}

export function generateFileUrl(sharedFile) {
	const userId = localStorage.getItem('userId');
	
	// Vérifier s'il y a un champ file_upload directement
	if (sharedFile.file_upload) {
		return sharedFile.file_upload;
	}
	
	// Fallback : construire le chemin manuellement
	const fileUrl = `users_files/${userId}/${sharedFile.class_name}/${sharedFile.name}`;
	return fileUrl;
}

export function generateFileUrlFromPath(filePath, className, fileName) {
	const userId = localStorage.getItem('userId');
	// S'assurer que tous les composants du chemin sont correctement encodés
	const encodedClassName = encodeURIComponent(className || '');
	const encodedFileName = encodeURIComponent(fileName || '');
	return `users_files/${userId}/${encodedClassName}/${encodedFileName}`;
}